import { useEffect, useState } from "react";
import { Modal, Box, Button, Typography, Container, ThemeProvider, Divider} from "@mui/material";
import theme from "./theme";

function MainPageApp() {
    const [open, setOpen] = useState(false); // State to control the popup
    const [targetUrl, setTargetUrl] = useState(null); // Store target URL

    const handleClose = () => {
        setOpen(false);
    };

    const handleTraditionalSearch = () => {
        handleClose();
        window.location.href = targetUrl; // Redirect to the target URL
    };

    const handleNewSearch = () => {
        handleClose();

        const treeType = targetUrl.split("/")[4]
        console.log(treeType)

        window.location.href = `/lists/search?treetype=${treeType}`; // Redirect using a new search URL
    };

    useEffect(() => {
        const buttons = document.querySelectorAll("[data-id='dadb915'] a");

        const handleButtonClick = (e) => {
            e.preventDefault(); // Prevent the default link navigation

            const anchor = e.target.closest("a");

            if (anchor) {
                console.log(anchor);
                setTargetUrl(anchor.href); // Set the target URL to use in the modal
                setOpen(true); // Open the modal
            }
        };

        buttons.forEach((button) => {
            button.addEventListener("click", handleButtonClick);
        });

        // Clean up the event listeners on component unmount
        return () => {
            buttons.forEach((button) => {
                button.removeEventListener("click", handleButtonClick);
            });
        };
    }, []); // Empty dependency array ensures this effect runs once

    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth="sm" style={{ textAlign: 'center', marginTop: '100px' }}>
                {/* Modal Popup */}
                <Modal open={open} onClose={handleClose} aria-labelledby="popup-title" aria-describedby="popup-description" disablePortal>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: { xs: '90%', sm: 500 }, // Responsive width
                            maxWidth: 500, // Maximum width to prevent overflow
                            bgcolor: '#E9E9E9',
                            borderRadius: 4,
                            boxShadow: 24,
                            p: { xs: 3, sm: 6 }, // Adjust padding based on screen size
                            textAlign: 'center',
                        }}
                    >
                        <Box textAlign="left" sx={{mb: 3}}>
                            <Typography variant="h5">
                                Kedves látogató!
                            </Typography>
                            <Typography>
                                Elindítunk egy újfajta keresőt, ami saját ötletünk alapján valósult meg! <br />
                                A szűrés alapján megjelenő fák között úgy tudsz válogatni, hogy jobbra húzással a „tetszik” dobozba kerül, balra húzással pedig a „kukába”. <br />
                                <br />
                                A tetszik dobozba húzott fákat tudod tovább szűrni, meg tudod osztani ismerősökkel, és szavaztatni tudod őket, hogy az általad kiválasztott fák közül kinek melyik tetszik a legjobban! A beérkező szavazatok megjelennek a listádban szereplő fák adatlapjánál!<br />
                                <br />
                                Több listát is készíthetsz!<br />
                                <br />
                                Nagyon örülnénk, ha visszajeleznétek, hogy mennyire tetszik nektek!<br />
                                <br />
                                Próbáljátok ki!
                            </Typography>
                        </Box>
                        <Divider />
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 4, mt: 3}}>
                            <Box flex={1}>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    onClick={handleTraditionalSearch} // Use the refactored function
                                >
                                    Hagyományos kereső
                                </Button>
                            </Box>
                            <Box flex={1}>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    onClick={handleNewSearch} // Use the refactored function
                                >
                                    Új kereső
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
            </Container>
        </ThemeProvider>
    );
}

export default MainPageApp;
